/* globals Raven */

import React, { Component } from "react";
import "./index.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Raven.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.error) {
      // render fallback UI
      return (
        <div className="error-message-container">
          <h1>Whoops!</h1>
          <p>We're sorry — something's gone wrong.</p>
          <p>Our team has been notified, but please click the button below to fill out a bug report.</p>
          <p>
            If you require immediate assistance, please feel free to contact the development team at{" "}
            <a href="mailto:cypinfrastructure@wspdigital.com">cypinfrastructure@wspdigital.com</a>, providing the
            following error ID:
          </p>

          <p>
            <code>{Raven.lastEventId()}</code>
          </p>

          <button
            className="btn btn-primary btn-bugreport"
            onClick={() => Raven.lastEventId() && Raven.showReportDialog()}
          >
            File a bug report
          </button>

          <hr />

          <a className="btn btn-default" href="/">
            Home
          </a>
          <button className="btn btn-default" onClick={() => window.location.reload(true)}>
            Reload Page
          </button>
        </div>
      );
    } else {
      // when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/_components/ErrorBoundary/index.js